import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const COOKIE_NAME = "p_qid";
const COOKIE_CLICK_NAME = "p_click_id";
const COOKIE_EMAIL_HASH_NAME = "p_em_h";
const COOKIE_DOMAIN = ".my-stylist.pro";
const COOKIE_TTL_MS = 30 * 24 * 60 * 60 * 1000; // ~30 days

const setCookie = (name, value) => {
  if (!value) return;

  const expires = new Date(Date.now() + COOKIE_TTL_MS).toUTCString();
  const cookieDomain = getCookieDomain();
  const cookieParts = [
    `${name}=${encodeURIComponent(value)}`,
    `expires=${expires}`,
    "path=/",
    "SameSite=Lax",
  ];
  if (cookieDomain) {
    cookieParts.splice(3, 0, `domain=${cookieDomain}`);
  }

  document.cookie = cookieParts.join("; ");
};

const getCookieDomain = () => {
  const hostname = window.location?.hostname || "";
  return hostname === "my-stylist.pro" || hostname.endsWith(".my-stylist.pro")
    ? COOKIE_DOMAIN
    : "";
};

const hashEmail = async (email) => {
  if (!email) return "";
  if (!window.crypto?.subtle) return "";

  const normalized = email.trim().toLowerCase();
  if (!normalized) return "";

  const encoder = new TextEncoder();
  const data = encoder.encode(normalized);
  const hashBuffer = await window.crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
};

export const useClientReferenceCookie = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search || "");
    // p_qid
    const rawValue = params.get("client_reference_id");
    const value = rawValue ? rawValue.trim() : "";
    if (value) {
      setCookie(COOKIE_NAME, value);
    }

    // p_click_id
    const rawClickId = params.get("p_click_id");
    const clickId = rawClickId ? rawClickId.trim() : "";
    if (clickId) {
      setCookie(COOKIE_CLICK_NAME, clickId);
    }

    // p_em_h
    const rawEmail = params.get("prefilled_email");
    const email = rawEmail ? rawEmail.trim() : "";
    if (email) {
      hashEmail(email).then((hashed) => {
        if (hashed) {
          setCookie(COOKIE_EMAIL_HASH_NAME, hashed);
        }
      });
    }
  }, [location.search]);
};
